import { Tag } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { useSliderContext } from '../../context/SliderContext';

import './MainSliderLabels.scss';

const MainSliderLabels = () => {
  const labels = useSliderContext();

  return (
    <div className="main-slider-label">
      {labels.checked ? (
        <Tag
          label={trans(labels.checked.text).toUpperCase()}
          renderLeadingIcon={() => labels.checked.icon}
          isDarkMode
        />
      ) : null}
    </div>
  );
};

export default MainSliderLabels;
